import { lazy, Suspense, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export function ContactDealerInlineFormLoaderRedesign({ load, ...props }) {
    const [LazyForm, setLazyForm] = useState(null);
    useEffect(() => {
        if (load && !LazyForm) {
            setLazyForm(
                lazy(() =>
                    import(
                        /* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineFormRedesign'
                    )
                )
            );
        }
    }, [load, LazyForm]);
    return (
        LazyForm && (
            <Suspense fallback={''}>
                <LazyForm {...props} />
            </Suspense>
        )
    );
}

ContactDealerInlineFormLoaderRedesign.propTypes = {
    load: PropTypes.bool,
};
